import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PublicuserService } from 'src/framework/services/publicuser.service';
import { MessageService } from 'primeng';
//import { Route } from '@angular/compiler/src/core';
import { CategoryConstant } from '../shared/app-constants/category-constants';
import { LanguageService } from 'src/framework/services/language.service';


@Component({
  selector: 'app-public-user-signup',
  templateUrl: './public-user-signup.component.html',
  styleUrls: ['./public-user-signup.component.css']
})
export class PublicUserSignupComponent implements OnInit {
  usersignUpId:any;
  unsubscribe:any;
  displayModal=false;
  modalMessage:any;

  selectedLanguageId: number;
  defaultEnglishJson: any;
  islabelLoaded: boolean = false;
  selectedAppLanguageJson: any;
  constructor(private router: ActivatedRoute,public service: PublicuserService,private messageService: MessageService,private languageSerivce: LanguageService,private route:Router) { }

  ngOnInit(): void {
    this.loadLanguageLabel();
    this.modalMessage="";
    this.router.queryParams.subscribe(params => {
      this.usersignUpId=parseInt(params.publicUserId);
      this.unsubscribe=params.unsubscribe;
      if(this.unsubscribe=="true"){
        this.unsubscribeEngagement(this.usersignUpId);
      }
      else{
      this.signUpEngagement(this.usersignUpId);
      }
    });
  }

  signUpEngagement(userId:number){
    this.service.signUpUser(userId).subscribe
    (res=> 
      {
        var responseData=res;
        var responses = res.data;
        if(responses){
          this.modalMessage="You have successfully subscribed to the Engagement";
          this.displayModal=true;
        }
        else{
          this.modalMessage=res.message;
          this.displayModal=true;
        }
      });
  }

  unsubscribeEngagement(userId:number){
    this.service.unsubscribeEngagement(userId).subscribe
    (res=> 
      {
        var responses =res;
        if(responses){
          this.modalMessage="You have successfully unsubscribed to the engagement";
          this.displayModal=true;
        }
        else{
          this.modalMessage="Your have already unsubscribed to the engagement";
          this.displayModal=true;
        }
      });
  }



  loadLanguageLabel() {
    let englishLanguageMappings, selectedLanguageMappings: any;

    return new Promise((resolve, reject) => {
      if (sessionStorage.getItem('selectedLanguageId')) {
        this.selectedLanguageId = 1;//JSON.parse(sessionStorage.getItem('selectedLanguageId'));
      }

      this.languageSerivce.currentData.subscribe(data => {
        this.selectedLanguageId = data.Id
      });


      this.languageSerivce.mySubject.subscribe((data) => {
        var languageMappings = data;
        if (languageMappings?.length > 0) {

          englishLanguageMappings = languageMappings.filter(item =>
            item?.categoryName?.toLowerCase() === CategoryConstant.EngagementDetail.toLowerCase()
            && Number(item?.languageId) === 1)[0];

          if (englishLanguageMappings?.isGlobal) {
            selectedLanguageMappings = languageMappings.filter(item =>
              item?.categoryName?.toLowerCase() === CategoryConstant.EngagementDetail.toLowerCase()
              && Number(item?.languageId) === Number(this.selectedLanguageId))[0];
          }
          else {
            if (Number(this.selectedLanguageId) === 2) {
              selectedLanguageMappings = languageMappings.filter(item =>
                item?.categoryName?.toLowerCase() === CategoryConstant.EngagementDetail.toLowerCase()
                && Number(item?.languageId) === Number(this.selectedLanguageId))[0];
            }
            else {
              selectedLanguageMappings = englishLanguageMappings;
            }
          }

          this.selectedAppLanguageJson = JSON.parse(selectedLanguageMappings.languageMappingJSON);

          this.defaultEnglishJson = JSON.parse(englishLanguageMappings.languageMappingJSON);

          this.islabelLoaded = true;

          resolve(1);
        }
        else {
        }
      });
    })
      .catch(err => {

        console.log(err);
      });
  }

  labelReplacer(labelKey): string {
    return this.selectedAppLanguageJson[labelKey]?.trim() ? this.selectedAppLanguageJson[labelKey] ?? 'text not found' : this.defaultEnglishJson[labelKey] ?? 'text not found';
  }



  NavigateHome(){
    this.route.navigate(["/home"]);
  }


}
